export const ResumeTemplateTypes = {
    STANDARD: 'standard',
    LINEAR: 'linear',
    // Add other template types as needed
};